export const text4xl = {
  fontSize: '2.25rem',
  lineHeight: '2.5rem'
};
export const text3xl = {
  fontSize: '1.875rem',
  lineHeight: '2.25rem'
};
export const text2xl = {
  fontSize: '1.5rem',
  lineHeight: '2rem'
};
export const textXl = {
  fontSize: '1.25rem',
  lineHeight: '1.75rem'
};
export const textLg = {
  fontSize: '1.125rem',
  lineHeight: '1.75rem'
};
export const textMd = {
  fontSize: '1rem',
  lineHeight: '1.5rem'
};
export const textSm = {
  fontSize: '0.875rem',
  lineHeight: '1.25rem'
};
export const textXs = {
  fontSize: '0.75rem',
  lineHeight: '1rem'
};
export const text2xs = {
  fontSize: '0.5rem',
  lineHeight: '.75rem'
};
export const textLabelSize = {
  fontSize: '0.75rem',
  lineHeight: '0.9rem'
};